import React from "react";

interface Props {
    path: string;
    fill?: string;
    width?: string;
    height?: string;
    viewBox?: string;
}

const Icon: React.FC<Props> = ({
    path,
    fill = "currentColor",
    width = "100%",
    height = "100%",
    viewBox = "0 0 512 512",
}) => {
    return (
        <svg
            viewBox={viewBox}
            fill={fill}
            width={width}
            height={height}
            fillRule="evenodd"
        >
            <path d={path} />
        </svg>
    );
};

export default Icon;
